import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  bankLogo: {
    width: 130,
    height: 80,
  },
  list: {
    "& li::marker": {
      color: theme.palette.info.main,
    },
  },
  buttonAction: {
    background: theme.palette.change.main,
    "&:hover": {
      background: theme.palette.change.main,
    },
  },
}));

export default useStyles;
